import { animation } from './_animation';
import { header } from './_header';
import { common } from './_common';
import { scroll } from './_scroll';
import { checkbox } from './_checkbox';
import { contactFrom } from './_contactFrom';
import { slide } from './_slide';
import { tab } from './_tab';
import { accordion } from './_accordion';
import { modal } from './_modal';

modal();
accordion();
tab();
slide();
contactFrom();
checkbox();
scroll();
common();
header();
animation();
